import strFunc from '@/lib/lyg/string';
import CoolenMoveUrl from "@/pcomponents/common/content/coolen/study/func/move_url";

function StudyArea(props: any) {
  const myProps = {
    rowData: {},
    study_info: {},
    study_idx: 0,
    studyXColumnArr: [],
    section_arr: [],
    study_arr: [],
    ...props
  };

  let study_info = myProps.study_info;
  let study_arr = myProps.study_arr;
  let section_arr = myProps.section_arr;
  let rowData = myProps.rowData;
  let row_title = "";
  if (rowData) {
    row_title = rowData["a_title"];
  }

  const getColumnInputTag = (inOptObj: any) => {
    if (inOptObj == undefined) { inOptObj = {}; }
    let optObj = {
      "key": "",
      "data": {},
      "row_num": 0,
      "key_i": 0,
      ...inOptObj
    };
    let key = optObj["key"];
    let val_str = "";
    if (optObj["data"][key] != undefined) {
      val_str = optObj["data"][key];
    }

    let tag_obj: any = (
      <span>{val_str}</span>
    );
    if (key == "row_view_num") {
      tag_obj = (<span>{myProps.study_idx + 1}</span>);
    } else if (key == "row_view_manage") {
      let pre_view_btn: any = "";
      let pre_view_btn2: any = "";
      let manage_btn: any = "";
      let word_cnt_str: any = "";
      let row_title_str = row_title + " - " + study_info.a_title;
      if (study_info.a_par_id == "contents_book" && !strFunc.is_empty(study_info.a_par_seq)) {
        pre_view_btn = (
          <button className="btn-s btn-gray ml-1"
            onClick={() => {
              CoolenMoveUrl.go_to_study_url({
                detail_info: study_info,
                study_is_save: "",
                is_new_window: "1",
                back_sort: "popup",
                title: row_title_str,
              });
            }}>미리보기</button>
        );
        manage_btn = (
          <button className='btn-s btn-gray ml-1'
            onClick={() => {
              if (strFunc.is_empty(study_info["a_book_seq"])) {
                return alert("저장 후 단어관리가 가능합니다.");
              }
              myProps.open_manage_word_popup({
                sort: "manage_word_cool",
                g_par_id: study_info.a_par_id,
                g_par_seq: study_info.a_par_seq,
              });
            }} >
            관리{word_cnt_str}
          </button>
        );
      } else if (study_info.a_par_id == "abc_study" && !strFunc.is_empty(study_info.a_par_seq)) {
        pre_view_btn = (
          <button className="btn-s btn-gray ml-1"
            onClick={() => {
              let study_list_pri_val = study_info["a_book_seq"] + "," + optObj["data"]["a_seq"];
              CoolenMoveUrl.go_to_url({
                coolen_study_par_id: "mtextbook_list",
                coolen_study_par_seq: study_list_pri_val,
                coolen_study_sort: "abc",
                study_is_save: "",
                is_new_window: "1",
                back_sort: "popup",
                title: row_title_str,
              });
            }}>미리보기</button>
        );
      } else if (study_info.a_par_id == "word_school") {
        pre_view_btn = (
          <button className="btn-s btn-gray ml-1"
            onClick={() => {
              CoolenMoveUrl.go_to_url({
                coolen_study_par_id: "mtextbook_list",
                coolen_study_par_seq: study_info["a_book_seq"] + "," + optObj["data"]["a_seq"],
                coolen_study_sort: "word_school",
                study_is_save: "",
                is_new_window: "1",
                back_sort: "popup",
                title: row_title_str,
              });
            }}>미리보기</button>
        );
      } else {
        if (study_info.cg_word_arr && study_info.cg_word_arr.length > 0) {
          word_cnt_str = "(" + study_info.cg_word_arr.length + ")";
          pre_view_btn2 = (
            <>
              <button className="btn-s btn-gray ml-1"
                onClick={() => {
                  CoolenMoveUrl.go_to_url({
                    coolen_study_par_id: "mtextbook_list",
                    coolen_study_par_seq: study_info["a_book_seq"] + "," + optObj["data"]["a_seq"],
                    coolen_study_sort: "word2",
                    study_is_save: "",
                    is_new_window: "1",
                    back_sort: "popup",
                    title: row_title_str,
                  });
                }}>미리보기</button>
              <button className="btn-s btn-gray ml-1"
                onClick={() => {
                  CoolenMoveUrl.go_to_url({
                    coolen_study_par_id: "mtextbook_list",
                    coolen_study_par_seq: study_info["a_book_seq"] + "," + optObj["data"]["a_seq"],
                    coolen_study_sort: "word",
                    study_is_save: "",
                    is_new_window: "1",
                    back_sort: "popup",
                    title: row_title_str,
                  });
                }}>미리보기2</button>
            </>
          );
        }
      }
      if(myProps.study_idx==0&&optObj["row_num"]==0){}else{
        pre_view_btn2="";
        pre_view_btn="";
      }
      tag_obj = (
        <div>
          {pre_view_btn2}
          {pre_view_btn}
        </div>
      );
    }

    return tag_obj;
  };

  let study_td_arr = myProps.studyXColumnArr.x_column_list_arr.map((column: any, column_idx: number) => {
    if (column["is_show"] != "1") {
      return "";
    }
    let tag_obj = getColumnInputTag({
      "key": column.key,
      "data": study_info,
      "row_num": study_info.row_num,
      "key_i": column_idx,
    });
    return (
      <td key={column_idx}>
        <div style={{ width: column["width"], textAlign: "center" }}>
          {tag_obj}
        </div>
      </td>
    );
  });

  return (
    <tr>
      {study_td_arr}
    </tr>
  );
}
export default StudyArea;